import template from './ktable-widget.html';
import controller from './ktable-widget.controller';
import './ktable-widget.scss';

/**
 * @type {import('angular').IComponentOptions}
 */
const component = {
	template: `${template}`,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
